module.exports = __webpack_public_path__ + "assets/img/2.7acee771.jpg";